import actions from './actions';

const ImageURLGeneratorModule = {
  namespaced: true,
  actions,
};

export default ImageURLGeneratorModule;
